<template>
    <!--
    Tab content being injected to the tabs component
    -->
    <div v-if="showContent">
        <slot />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default
{
    name: 'Tab',

    props: {
        index: { required: true, default: 0, },
        title: { required: false, default: '', },
        count: { required: false },
    },

    computed:
    {
        /**
         * Show tab content if
         *  page is in mobile viewport
         *  and page has a tab for the main content
         *  and active tab index equals tab index
         *
         * if page is not in mobile viewport
         *  show tab content when active index equals tab index
         *  or if active tab index equals 0 and tab index equals 1
         *
         * otherwise show content tab if active tab equals tab index
         *
         * @returns {boolean}
         */
        showContent()
        {
            if (this.index == 0 && this.mainContentTab)
                return false;

            if (this.isMobile && this.mainContentTab)
            {
                return this.index == this.activeTab;
            }
            else if (this.mainContentTab)
            {
                return (this.index == this.activeTab || this.activeTab == 0 && this.index == 1);
            }
            else
            {
                return this.index == this.activeTab;
            }
        },

        // Is viewport in mobile mode
        isMobile()
        {
            return this.viewport != 'd' && this.viewport != 'tl';
        },

        ...mapState({
            viewport: ({ layout }) => layout.viewport,
            activeTab: ({ sidebar }) => sidebar.tab.activeTab,
            mainContentTab: ({ sidebar }) => sidebar.tab.mainContentTab,
        }),
    },
}
</script>



// WEBPACK FOOTER //
// Tab.vue?716f3de0